import React from 'react';
import DialogBox1 from '../assets/images/Background/dialogBox1.png'
import DialogBox2 from '../assets/images/Background/dialogBox2.png'
import { Dialog, DialogContent, Grid, Button, Typography, Box } from '@material-ui/core';

const Modal = (props) => {
  return (
    <Dialog maxWidth={false} PaperProps={{ style: { background: `url(${DialogBox2}) top right no-repeat, url(${DialogBox1}) bottom left no-repeat`, backgroundColor: 'white', borderRadius: '3px' } }} open={props.open} onClose={props.onClose}>
      <DialogContent style={{ minWidth: '475px', padding: "30px 40px 15px" }}>
        <Typography style={{ textAlign: "center", fontWeight: "bold", fontSize: '28px' }}>
          {props.modalName.toUpperCase()}
        </Typography>
        <Box padding="15px 65px 30px">
          {props.children}
        </Box>
        {
          props.hideButtons ? null :
            <Grid item>
              <Grid container justify='flex-end' direction='row' spacing={2}>
                {props.onClose &&
                  <Grid item>
                    <Button onClick={props.onClose} variant="outlined" color="primary" style={{ fontWeight: 600 }}>
                      {props.closeName || "VOLTAR"}
                    </Button>
                  </Grid>
                }
                {props.action &&
                  <Grid item>
                    <Button variant="contained" onClick={props.action} disabled={props.isUploading} style={{  backgroundColor: "#C6A489", color: 'white', fontWeight: 600 }}>
                      {props.actionName || "SALVAR"}
                    </Button>
                  </Grid>
                }
              </Grid>
            </Grid>
        }
      </DialogContent>
    </Dialog>
  )
}

export default Modal;
